import React from 'react'

import { Modal, Button } from 'semantic-ui-react'

import { Team } from '../types'

export interface InformationModalProps {
  isOpen?: boolean,
  onClose: () => void,
  header: string,
  content?: string,
  team?: Team
}

export default function InformationModal(props: InformationModalProps) {
  return (
    <Modal
      open={props.isOpen}
      onClose={props.onClose}
      className='melee-modal'
    >
      <Modal.Content>
        <div style={{ marginBottom: 32, textShadow: "2px 2px 3px black" }}>
          <h2>{props.header}</h2>
        </div>
        <p>{props.content}</p>
        <div className='action' style={{ marginTop: '3em' }}>
                    <Button
                        basic color='yellow' inverted onClick={props.onClose}>
                        Lukk
                    </Button>
                </div>
      </Modal.Content>
    </Modal>
  )
}